<template>
    <Vue100vh class="univers-wrap" @click.native="handleGlobalClick($event)">
	    <div id="timer" v-if="showWelcome">
		    <div class="wrapper">
			    <div class="welcome-wrap">
				    <div class="welcome-box">
					    <h2>Velkommen til Vorbasse Hjemmmemarked 2020</h2>
					    <p>Vi er super glade for at se dig. Kig indenfor, og lad dig inspirere til god markedsstemning.</p>
					    <br/>
					    <button class="green" @click="getInWithOutAuth">Kom indenfor</button>
				    </div>
			    </div>
		    </div>
	    </div>
        <div v-else id="univers" class="draggable" :style="transform" :data-x="screenX"  :data-y="screenY" ref="universDraggable">
            <div id="univers-img" v-if="isReady">

                <IsoItem x="0" y="1"></IsoItem>
                <IsoItem x="0" y="2" type="dandomain"><template v-slot:name><img :src="'/iso-elements/Dandomain.svg?v='+version" /></template></IsoItem>
                <IsoItem x="0" y="3" type="billboard"><template v-slot:name><img :src="'/iso-elements/Billboard.svg?v='+version" /></template></IsoItem>

                <IsoItem x="1" y="0"></IsoItem>
                <IsoItem @click.native="clickRouter($event,'info/camping')" x="1" y="1" type="telte"><template v-slot:name><img :src="'/iso-elements/Telte.svg?v='+version" /></template></IsoItem>
                <IsoItem x="1" y="2" type="royalunibrew"><template v-slot:name><img :src="'/iso-elements/RoyalUnibrew.svg?v='+version" /></template></IsoItem>
	            <AsyncResource resource="/assets/univers/animation/tivoli.json" v-slot:default="props">
	                <IsoItem @click.native="clickRouter($event,'tivoli')" x="1" y="3" type="tivoli">
		                <template v-if="!isTransitioning && props.resourceFetched && props.data !== null" v-slot:ani><lottie :options="{animationData: props.data,autoplay: true,loop: true}" :width="384" :height="400" v-on:animCreated="handleAnimation($event,'tivoli')"/></template>
	                    <template v-else v-slot:name><img :src="'/iso-elements/Tivoli.svg?v='+version" /></template>
	                </IsoItem>
	            </AsyncResource>
                <IsoItem x="1" y="4"></IsoItem>

                <IsoItem x="2" y="0"></IsoItem>
                <IsoItem @click.native="clickRouter($event,'info/heste-og-smaadyr')" x="2" y="1" type="horses"><template v-slot:name><img :src="'/iso-elements/Horses.svg?v='+version" /></template></IsoItem>
                <IsoItem x="2" y="2" type="traeer"><template v-slot:name><img :src="'/iso-elements/Traeer.svg?v='+version" /></template></IsoItem>
	            <AsyncResource resource="/assets/univers/animation/oelteltet.json" v-slot:default="props">
	                <IsoItem @click.native="clickRouter($event,'oelteltet')" x="2" y="3" type="oeltelt">
		                <template v-if="!isTransitioning && props.resourceFetched && props.data !== null" v-slot:ani><lottie :options="{animationData: props.data,autoplay: true,loop: true}" :width="384" :height="348" v-on:animCreated="handleAnimation($event,'oelteltet')"/></template>
		                <template v-else v-slot:name><img :src="'/iso-elements/Oeltelt.svg?v='+version" /></template>
	                </IsoItem>
	            </AsyncResource>
	            <AsyncResource resource="/assets/univers/animation/flag.json" v-slot:default="props">
	                <IsoItem @click.native="clickRouter($event,'info/markedsinfo')" x="2" y="4" type="information">
	                    <template v-slot:name><img :src="'/iso-elements/Information.svg?v='+version" /></template>
	                    <template v-if="!isTransitioning && props.resourceFetched && props.data !== null" v-slot:ani><lottie :options="{animationData: props.data,autoplay: true,loop: true}" :width="79" :height="254" v-on:animCreated="handleAnimation($event,'flag')"/></template>
		                <template v-else v-slot:ani><img :src="'/iso-elements/Flag.svg?v='+version" /></template>
	                </IsoItem>
	            </AsyncResource>
                <IsoItem @click.native="clickWelcome" x="2" y="5" type="velkommen"><template v-slot:name><img :src="'/iso-elements/Velkommen.svg?v='+version" /></template></IsoItem>

                <IsoItem @click.native="clickRouter($event,'esport')" x="3" y="0" type="esport">
	                <template v-slot:name><img :src="'/iso-elements/Esport.svg?v='+version" :width="380" :height="314" /></template>
                </IsoItem>
                <IsoItem x="3" y="1" type="guloggratis"><template v-slot:name><img :src="'/iso-elements/GulOgGratis.svg?v='+version" /></template></IsoItem>
                <IsoItem @click.native="clickRouter($event,'boderne')" x="3" y="2" type="boder2"><template v-slot:name><img :src="'/iso-elements/Boder2.svg?v='+version" /></template></IsoItem>
                <IsoItem @click.native="clickRouter($event,'boderne')" x="3" y="3" type="boder1"><template v-slot:name><img :src="'/iso-elements/Boder1.svg?v='+version" /></template></IsoItem>
                <IsoItem x="3" y="4"></IsoItem>
                <IsoItem x="4" y="1"></IsoItem>
                <IsoItem @click.native="clickTshirt" x="4" y="2" type="tshirt"><template v-slot:name><img :src="'/iso-elements/T-shirt-optimized.svg?v='+version" /></template></IsoItem>

	            <AsyncResource resource="/assets/univers/animation/partytruck.json" v-slot:default="props">
	                <IsoItem @click.native="clickRouter($event,'partytruck')" x="4" y="3" type="lastbil">
		                <template v-if="!isTransitioning && props.resourceFetched && props.data !== null" v-slot:ani><lottie :options="{animationData: props.data,autoplay: true,loop: true}" :width="380" :height="323" v-on:animCreated="handleAnimation($event,'partytruck')"/></template>
	                    <template v-else v-slot:name><img :src="'/iso-elements/Lastbil.svg?v='+version" /></template>
	                </IsoItem>
	            </AsyncResource>
                <IsoItem x="5" y="2"></IsoItem>
            </div>
        </div>

        <div class="logo" v-if="!showWelcome">
            <Logo/>
        </div>

    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
	import interact from 'interactjs'
	import IsoItem from "@/components/IsoItem";
	import {mapState} from 'vuex'
    import gsap from 'gsap'

	import Landingpage from "@/components/Landingpage";

    import Logo from '@/assets/univers/logo-with-shadow.svg'

    import Busk from '@/assets/univers/countdown/busk.svg'
	import Sky from '@/assets/univers/countdown/sky.svg'
    import CountdownLogo from '@/assets/univers/countdown/logo.svg'

    // Animation
	import Lottie from 'vue-lottie'
	import AsyncResource from "@/components/resources/AsyncResource";

	import {getCookie, setCookie} from "@/helperFunctions";

	export default {
        components: {
	        Landingpage,
	        Vue100vh,
			Lottie,
	        IsoItem,
            Logo,
            Busk,
            Sky,
	        CountdownLogo,
	        AsyncResource
        },
		data() {
			return {
				version: process.env.VUE_APP_STATIC_CONTENT_VERSION,
				window: {
					width: 0,
                    height: 0
                },
                isReady: false,
                isDragging: false,
                isClicked: false,
				showTshirt:false,
				isTransitioning: true,
				goingToRoute:false,
                hjaelpepakkeSalgIsOpen: false,
                anims: {
					esport: false,
                    partytruck: false,
                    donation: false,
                    oelteltet: false,
                    tivoli: false,
                    flag: false
                }
			};
		},
		mounted: function() {
			//this.$store.commit('vorbasse/setSearchQuery','');
			//this.$store.commit('vorbasse/setSearchProducts',[]);
			//this.$store.commit('vorbasse/setNextSearchPage',false);
			this.$store.commit('vorbasse/setSearchScroll', 0)

			if(!this.showWelcome){
				this.buildUniversWithDelay()
				let hasSeenWelcomeCheck = getCookie('hasSeenWelcomeScreen')
				if(typeof hasSeenWelcomeCheck === 'undefined'){
					setCookie('hasSeenWelcomeScreen', 'true', 24*365)
					this.$store.commit('ux/setHasSeenWelcomeScreen',true);
				}
            }else{
				this.addIsLandingFromDom()
            }
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.onResize);
		},
		methods: {
			handleGlobalClick(event){
				if(typeof event.target !== 'undefined' && this.guideState !== '')
				{
					if(typeof event.target.id !== 'undefined' && event.target.id === 'univers-img')
					{
						this.$store.commit("ux/setGuideState", 'close')
					}
					else
					{
						const iso = event.target.closest('.iso');
						if(iso !== null)
						{
							const unacceptedClasses = ['oeltelt','boder1','boder2','tivoli','lastbil','esport','velkommen'];
							let found = false;
							for (let value of iso.classList) {
								if(unacceptedClasses.indexOf(value) !== -1)
								{
									found = true;
									break;
								}
							};
							
							if(!found)
							{
								this.$store.commit("ux/setGuideState", 'close')
							}
						}
					}
				}
			},
			getInWithOutAuth(){
				setCookie('hasSeenWelcomeScreen', 'true', 24*365)
                this.$store.commit('ux/setHasSeenWelcomeScreen',true);
				this.countdown = false
				this.buildUniversWithDelay()
                if(this.guideState !== ''){
	                this.$store.commit("ux/setGuideState", 'close')
                }
                let that = this
                setTimeout(function(){
                	that.$store.commit("ux/setGuideState", 'welcome')
                }, 3000)
            },
			windowOpen(url){
				window.open(url)
            },
            buildUniversWithDelay(){
                this.removeIsLandingFromDom()
	            if(typeof this.$refs.universDraggable !== 'undefined')
	            {
		            this.buildUnivers()
	            }
	            else
	            {
		            const that = this;
		            const interval = setInterval(() => {
			            if(typeof this.$refs.universDraggable !== 'undefined')
			            {
				            clearInterval(interval)
				            that.buildUnivers()
			            }
		            },100)
	            }
            },
			addIsLandingFromDom(){
				let html = document.getElementsByTagName('html')
				html[0].classList.add('is-landing')
			},
            removeIsLandingFromDom(){
				let html = document.getElementsByTagName('html')
                html[0].classList.remove('is-landing')
            },
			buildUnivers(){
				let universDraggable = this.$refs.universDraggable;
				this.initInteract(universDraggable);
				window.addEventListener('resize', this.onResize);
				this.setWindowSize()
				if(this.screenX === 0 && this.screenY === 0 ){
					this.onResize()
				}else{
					this.isReady = true
				}

				const that = this;
				setTimeout(function(){
					gsap.fromTo('.iso .inner', {
						y: 150,
						//y: 20,
					},{
						duration: 1.5,//1,
						force3D: true,
						opacity: 1,
						y: 0,
						ease: 'Elastic.easeOut',
						stagger: 0.1,
					})
					.then(() => {
						that.isTransitioning = false;
					})
				}, 200)
            },
			handleAnimation: function (event,type) {
				this.anims[type] = event;
			},
            setWindowSize() {
	            this.window.width = window.innerWidth
	            this.window.height = window.innerHeight
            },
			onResize() {
				this.setWindowSize()
				this.initialPosition()
			},
            clickTshirt(){
	            if(this.isDragging) return;
	            this.$store.commit("ux/setShowTshirtPopup", true)
            },
			clickWelcome(){
				if(this.isDragging) return;
				this.$store.commit('ux/setGuideState','welcome')
			},
			findAncestor (el, sel) {
                while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
                return el;
            },
			clickRouter(event,to){
				if(this.isDragging || this.isClicked ) return;

				if(!this.isAuthorized){
					let requiresAuthPages = ['oelteltet','boderne','tivoli','esport','partytruck']
                    if(requiresAuthPages.indexOf(to) !== -1){
	                    this.changeRoute(to);
	                    return;
                    }
                }

				// if guide is open on click - close
				if(this.guideState !== ''){
					this.$store.commit("ux/setGuideState", 'close')
                    return;
				}

				// Clear animations
                gsap.killTweensOf('.iso .inner')
                this.isClicked = true

				let that = this
                let clickedElement = event.target.classList.contains('inner') ? event.target : this.findAncestor(event.target,'.inner')
				clickedElement.classList.add('clicked');
                gsap.to('.iso .inner:not(.clicked)', {
                    duration: 0.5,
                    opacity: 0,
                    y: 150,
                    ease: 'power1.easeOut',
                    stagger: 0.05
                })

                let bounds = clickedElement.getBoundingClientRect()
                let hww = this.window.width / 2
                let hwh = this.window.height / 2
                let hiw = bounds.width / 2
                let hih = bounds.height / 2
                let it = bounds.top
                let il = bounds.left
                let newX = (hww - hiw - il)
                let newY = (hwh - hih - it)

                gsap.to('.iso .inner.clicked', {
                    delay: 0.5,
                    duration: 0.5,
                    x: newX+'px',
                    y: newY+'px',
                    ease: 'power1.easeOut',
                })

                gsap.to(this.$refs['universDraggable'], {
                	delay: 0.5,
                    duration: 1,
                    scale: 1,
                    ease: 'power1.easeOut'
                })

                gsap.to('.logo', {
                    delay: 2,
                    duration: 0.5,
                    y: '-50',
                    opacity: 0,
                    ease: 'power1.easeOut',
                })

                let tl = gsap.timeline();
                tl.to(".iso .inner.clicked", {delay: 1.5, y: newY - 30, duration: 0.5});
                tl.to(".iso .inner.clicked", {y: newY + 30, duration: 0.5});
                tl.to(".iso .inner.clicked", {y: newY - 30, duration: 0.5});
                tl.to(".iso .inner.clicked", {y: newY + 30, duration: 0.5});
                tl.to(".iso .inner.clicked", {opacity: 0, duration: 0.3, onComplete:function() {
                    that.changeRoute(to);
                }});

            },
            changeRoute(to){
	            this.$router.push(to)
            },
			initInteract: function(selector) {
				let that = this;
				interact(selector)
				// .gesturable({
				// 	onmove(event){
				// 		that.dragMoveListener(event,'pinch')
				// 	},
				// 	onend(event){
				// 		that.onDragEnd(event)
				// 	}
				// })
				.draggable({
					inertia: true,
					modifiers: [
						interact.modifiers.restrictRect({
							restriction: 'parent',
							endOnly: true
						})
					],
					autoScroll: false,
					onmove(event){
						that.dragMoveListener(event,'move')
					},
					onend(event){
						that.onDragEnd(event)
					}
				})
				.on('tap', function (event) {
					if(typeof event.target !== 'undefined'){
						const parent = event.target.closest('.iso');
						if(parent !== null){
							if(typeof event.target.click !== 'undefined')
							{
								event.target.click();
							}
							else
							{
								event.target.closest('.inner').click();
							}
						}
					}
				});
			},
			dragMoveListener: function(event,type) {
                if(this.isClicked === true) return
				this.isDragging = true

                // if guide is open on drag - close
                if(this.guideState !== ''){
	                this.$store.commit("ux/setGuideState", 'close')
                }

				var target = event.target;
				var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
				var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
				var translate = 'translate(' + x + 'px, ' + y + 'px) scale('+this.storedScale+')';
				if(type === "pinch"){

					// var x = ((event.box.left + event.box.width) / 2) + (Math.abs(parseFloat(event.target.getAttribute('data-x'))))
					// var y = ((event.box.top + event.box.height) / 2) + (Math.abs(parseFloat(event.target.getAttribute('data-y'))))
					// event.target.style.webkitTransformOrigin = event.target.style.transformOrigin = x + 'px ' + y + 'px'

					var currentScale = this.storedScale * event.scale;
					if(currentScale > 1){
						currentScale = 1
					}else if(currentScale < 0.5){
						currentScale = 0.5;
					}
					translate = 'translate(' + x + 'px, ' + y + 'px) scale('+currentScale+')';
				}
				target.style.webkitTransform = target.style.transform = translate
				target.setAttribute('data-x', x)
				target.setAttribute('data-y', y)
			},
			onDragEnd: function(event) {
				var target = event.target;
				if(typeof event.scale !== "undefined"){
					let currentScale = this.storedScale * event.scale;
					if(currentScale > 1){
						currentScale = 1
					}else if(currentScale < 0.5){
						currentScale = 0.5;
					}
                    this.$store.commit("ux/setUniversScale", currentScale)
				}

				var x = (parseFloat(target.getAttribute("data-x")) || 0);
				var y = (parseFloat(target.getAttribute("data-y")) || 0);

				this.$store.commit("ux/setUniversX", x)
				this.$store.commit("ux/setUniversY", y)

				let that = this
				setTimeout(function(){
					that.isDragging = false
                }, 300);
			},
			initialPosition(){
				let universWidth = 2000
				let universHeight = 1350
				let x = (this.window.width - universWidth) / 2
				let y = (this.window.height - universHeight) / 2
				this.$store.commit("ux/setUniversX", x)
				this.$store.commit("ux/setUniversY", y)
				this.isReady = true
				return true
			}
		},
        computed: {
			...mapState('ux', {
                screenX: state => state.univers.x,
				screenY: state => state.univers.y,
				storedScale: state => state.univers.scale,
                guideState: state => state.states.guide,
				hasSeenWelcomeScreen: state => state.hasSeenWelcomeScreen
            }),
            ...mapState('vorbasse', {
	            isAuthorized: state => state.isAuthorized,
            }),
            transform(){
				return "transform: translate("+this.screenX+"px, "+this.screenY+"px) scale("+this.storedScale+"); cursor: move;"
            },
	        showWelcome(){
		        return (this.hasSeenWelcomeScreen === false && !this.isAuthorized);
	        }
        }
	}
</script>

<style lang="scss" scoped>

    #timer{
        .logo-holder{
            max-width: 1050px;
            margin: 0px auto;
            display: block;
            width: 100%;
            position: relative;
            z-index: 99998;
            height: 0;
            .countdown-logo{
                position: relative;
                top: 15px;
                left: 15px;
                @media(max-width: 767px){
                    top: 10px;
                    left: 50%;
                    transform: translateX(-50%) scale(0.6);
                }
                @media(max-width: 850px) and (orientation: landscape){
                    top: 10px;
                    left: 50%;
                    transform: translateX(-50%) scale(0.6);
                }
            }
        }

        .welcome-wrap{
            position: fixed;
            top: 0; left: 0;
            right: 0; bottom: 0;
            background: rgba(0,0,0,0.75);
            z-index: 99999;
            .welcome-box{
                background: #FFF;
                padding: 30px 50px 60px;
                margin: 0px auto;
                border-radius: 40px;
                text-align: left;
                white-space: normal;
                max-width: 500px;
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                button{
                    text-transform: none;
                }
                @media(max-width: 767px){
                    padding: 20px 30px 50px;
                }
            }
        }
        .wrapper{

            .inner-wrap{
                padding: 20px 45px 35px;
                background: #4b606b;
                border-radius: 0px;
                white-space: nowrap;
                text-align: center;
                .getReadyText{
                    font-size: 18px;
                    color: #FFF;
                }
                .koebEntreButton{
                    width: 490px;
                    max-width: 90vw;
                    margin: 15px auto 0px;
                }
                .item{
                    display: inline-block;
                    text-align: center;
                    padding: 10px;
                    border-radius: 10px;
                    border: 2px solid $white;
                    width: 100px;
                    margin: 0px 15px;
                    span{
                        display: block;
                        white-space: nowrap;
                        color: $white;
                        &.count{
                            font-size: 40px;
                            font-weight: bold;
                        }
                        &.text{
                            font-size: 16px;
                        }
                    }
                }
                @media(max-width: 767px){
                    padding: 10px 0px 30px;
                    .item{
                        width: auto;
                        margin: 0px 5px;
                        span{
                            &.count{
                                font-size: 22px;
                                font-weight: bold;
                            }
                            &.text{
                                font-size: 12px;
                            }
                        }
                    }
                }
                @media(max-width: 850px) and (orientation: landscape){
                    padding: 30px 0px;
                    .item{
                        width: auto;
                        margin: 0px 5px;
                        span{
                            &.count{
                                font-size: 22px;
                                font-weight: bold;
                            }
                            &.text{
                                font-size: 12px;
                            }
                        }
                    }
                }
                @media(max-width: 374px){
                    .item{
                        margin: 0px;
                        transform: scale(0.8);
                    }
                }
            }
        }

        .buttons-wrapper{
            display: block;
            max-width: 490px;
            margin: 50px auto;
            button{
                text-transform: none;
                color: $dark;
                .green{
                    background: $green;
                    color: $white;
                }
            }
            @media(max-width: 767px){
                margin: 30px auto;
                max-width: 290px;
                .row{
                    .col{
                        float: none;
                        width: 100%;
                    }
                }
                button{
                    margin-bottom: 15px;
                }
            }
        }

    }

    .iso{
	    img{
		    cursor: pointer;
	    }
    }

    .univers-wrap{
        position: fixed;
        top: 0px;
        left: 0px;
        display: block;
        width: 100vw;
        background: $sky;
	    touch-action: none;
        .logo{
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translateX(-55%);
        }
        #univers{
            position: absolute;
            top: 0;
            left: 0;
            transform-origin: center center;
            &.animate{
                transition: all .3s linear;
            }
            #univers-img{
                display: block;
                width: 2000px;
                height: 1350px;
                position: relative;
            }
        }
    }
</style>
